import React, { useEffect } from "react";
import { Modal, Form, Input, Select, notification } from "antd";

const { Option } = Select;

const VariantModal = ({ visible, onClose, onSave, editingVariant }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editingVariant) {
      form.setFieldsValue({
        name: editingVariant.name,
        values: editingVariant.values || [], // Set array of values
        status: editingVariant.status || "Active",
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ status: "Active", values: [] });
    }
  }, [editingVariant, visible]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      onSave(values);
      form.resetFields();
    } catch (error) {
      notification.error({ message: "Please fill in all required fields!" });
    }
  };

  return (
    <Modal
      title={editingVariant ? "Edit Variant" : "Add Variant"}
      visible={visible}
      onCancel={onClose}
      onOk={handleSave}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Variant Name"
          rules={[{ required: true, message: "Please enter a variant name!" }]}
        >
          <Input />
        </Form.Item>

        {/* ✅ Multi-value Input using Antd Select with "tags" mode */}
        <Form.Item
          name="values"
          label="Variant Values (Comma Separated)"
          rules={[
            { required: true, message: "Please add at least one value!" },
          ]}
        >
          <Select mode="tags" placeholder="Type a value and press Enter" />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select a status!" }]}
        >
          <Select>
            <Option value="Active">Active</Option>
            <Option value="Inactive">Inactive</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default VariantModal;
